import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-employee-attendance-response-dialog',
  templateUrl: './employee-attendance-response-dialog.component.html',
  styleUrl: './employee-attendance-response-dialog.component.scss',
  animations: [
    trigger('textAnimation', [
      state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
      transition('void => *', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('500ms ease-out'),
      ]),
    ]),
    trigger('rotateAnimation', [
      state('rotate', style({ transform: 'rotate(360deg)' })),
      transition('* => rotate', animate('1000ms ease-in')),
    ]),
  ],
})
export class EmployeeAttendanceResponseDialogComponent implements OnInit {
  rotateState: string = '';
  textAnimationState: string = 'visible';
  employee: {
    isMultiple: boolean;
    isCheckIn: boolean;
    isCheckOut: boolean;
    employeeDescriptor: any;
    employeeName: string;
    employeeProfile: string;
    employeeId: string;
    employeeNumber: string;
  } = null;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isMultiple: boolean;
      isCheckIn: boolean;
      isCheckOut: boolean;
      employeeDescriptor: any;
      employeeName: string;
      employeeProfile: string;
      employeeId: string;
      employeeNumber: string;
    }
  ) {
    this.employee = data;
  }
  ngOnInit() {
    // Trigger rotation every 3 seconds
    setInterval(() => {
      this.rotateState = 'rotate';
      setTimeout(() => {
        this.rotateState = ''; // Reset the state to trigger the next animation
      }, 1000);
    }, 5000);

    setInterval(() => {
      // Toggle the text animation state between 'visible' and 'void'
      this.textAnimationState =
        this.textAnimationState === 'visible' ? 'void' : 'visible';
    }, 500); // Change the interval time as needed
  }
}
